export default __webpack_public_path__ + "static/2-f54df49950c145f984658cdd22909fb0.png";